
import React, {useCallback, useEffect, useMemo} from 'react';
import {createDefaultImageWriter, getEditorDefaults} from "@pqina/pintura";
import {PinturaEditorModal} from "@pqina/react-pintura";
import {
  locale_en_gb,
  markup_editor_locale_en_gb,
  plugin_crop_locale_en_gb,
  plugin_annotate_locale_en_gb,
  plugin_decorate_locale_en_gb,
  plugin_filter_locale_en_gb,
  plugin_finetune_locale_en_gb,
  plugin_resize_locale_en_gb,
  plugin_sticker_locale_en_gb,
  plugin_redact_locale_en_gb,
  plugin_frame_locale_en_gb,
} from '@pqina/pintura';
import {SELFIE_STATE, useSelfieUploadState} from "../selfie_context";
import {readFileAsDataURL} from "../utils";
import '@pqina/pintura/pintura.css';

const defaultPinturaConfig = {
  "imageCropAspectRatio": 1920 / 1080,
  "imageWriter": {
    "targetSize": {
      "width": 1920,
      "height": 1080,
      "fit": "force",
      "upscale": true
    }
  },
  "enableUtils": false,
  "imageFlipX": false,
  "imageCropLimitToImage": false,
  "imageBackgroundColor": [
    255,
    255,
    255
  ],
  "locale": {
    "labelClose": "Abbrechen",
    "labelButtonRevert": "Rückgängig",
    "labelButtonUndo": "Rückgängig",
    "labelButtonRedo": "Wiederholen",
    "labelButtonExport": "Fertig",
    "cropLabelButtonRotateLeft": "nach Links drehen",
    "cropLabelButtonFlipHorizontal": "Spiegeln",
    "cropLabelTabRotation": "Drehung",
    "cropLabelTabZoom": "Zoom"
  }
}

export const Pintura = () => {
  const {
    file,
    setFile,
    pinturaConfig: statePinturaConfig,
    setState,
    targetWidth,
    targetHeight,
  } = useSelfieUploadState()
  const [fileUrl, setFileUrl] = React.useState(null)

  useEffect(() => {
    readFileAsDataURL(file)
      .then((url) => {
        setFileUrl(url)
      })
  }, [file]);

  const editorConfig = useMemo(() => {
    return getEditorDefaults();
  }, [])

  const pinturaConfig = useMemo(() => {
    if (statePinturaConfig) {
      try {
        return JSON.parse(statePinturaConfig)
      } catch (e) {
        alert(e)
      }
    } else {
      if (targetWidth && targetHeight) {
        return {
          ...defaultPinturaConfig,
          "imageCropAspectRatio": targetWidth / targetHeight,
          "imageWriter": {
            ...defaultPinturaConfig.imageWriter,
            "targetSize": {
              ...defaultPinturaConfig.imageWriter.targetSize,
              "width": targetWidth,
              "height": targetHeight,
            }
          },
        }
      } else {
        return defaultPinturaConfig
      }
    }

    return {}
  }, [
    statePinturaConfig,
    targetWidth,
    targetHeight,
  ])

  console.log("pinturaConfig", {pinturaConfig})

  const handleEditorHide = useCallback(() => {
  }, []);

  const handleEditorProcess = useCallback((imageState) => {
    setFile(imageState.dest)
    setState(SELFIE_STATE.PREVIEW)
  }, [setFile, setState])

  const pinturaEditorModal = useMemo(() => {
    if (!fileUrl) {
      return null
    }

    const {locale, imageWriter, ...currentPinturaConfig} = pinturaConfig

    if (locale) {
      currentPinturaConfig.locale = {
        ...locale_en_gb,
        ...plugin_annotate_locale_en_gb,
        ...plugin_crop_locale_en_gb,
        ...plugin_decorate_locale_en_gb,
        ...plugin_filter_locale_en_gb,
        ...plugin_finetune_locale_en_gb,
        ...plugin_resize_locale_en_gb,
        ...plugin_sticker_locale_en_gb,
        ...plugin_redact_locale_en_gb,
        ...plugin_frame_locale_en_gb,
        ...markup_editor_locale_en_gb,
        ...locale
      }
    }

    const currentImageWriter = createDefaultImageWriter(imageWriter)

    return <PinturaEditorModal
      {...editorConfig}
      src={fileUrl}
      {...currentPinturaConfig}
      imageWriter={currentImageWriter}
      onHide={handleEditorHide}
      onProcess={handleEditorProcess}
      enableButtonClose={false}
    />
  }, [fileUrl, editorConfig, pinturaConfig, handleEditorHide, handleEditorProcess])

  return <>
    {pinturaEditorModal}
  </>
}